import { render, staticRenderFns } from "./NewEditGestaoDeAulaPage.vue?vue&type=template&id=40a72526"
import script from "./NewEditGestaoDeAulaPage.vue?vue&type=script&lang=js"
export * from "./NewEditGestaoDeAulaPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditGestaoDeAulaPage.vue?vue&type=style&index=0&id=40a72526&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports